import { PropTypes } from "prop-types"
import { components } from "react-select"

export function SelectInput(props) {
  const { selectProps } = props
  const errorId = `${selectProps.inputId}-error`
  const ariaDescribedby = selectProps.error?.hasError ? errorId : selectProps.ariaDescribedBy

  return (
    <components.Input
      {...props}
      autoComplete={selectProps.autoComplete || "off"}
      required={selectProps.required}
      aria-invalid={Boolean(selectProps.error?.hasError)}
      aria-describedby={ariaDescribedby}
    />
  )
}

SelectInput.propTypes = {
  selectProps: PropTypes.shape({
    ariaDescribedBy: PropTypes.string,
    autoComplete: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.shape({
      hasError: PropTypes.bool
    }),
    inputId: PropTypes.string,
    label: PropTypes.node,
    readOnly: PropTypes.bool,
    required: PropTypes.bool
  })
}

export default SelectInput
